import type { AnyAction } from "redux";

import type { TypedAction } from "../../../../generic/redux/TypedRedux";

import {
	GO_LIVE_REQUESTED,
	GO_LIVE_SUCCESS,
	SET_LAST_SELECTED_DYNAMIC_INTERVAL,
	TIMELINE_UPDATE_REQUESTED,
	TIMESTAMP_ADDED_TO_HISTORY,
	TIMESTAMP_UPDATE_SUCCESS,
} from "./TimelineActionTypes";
import type { TimeRange } from "./TimeRange";

export interface TimestampUpdateSuccessData {
	timestamp?: Date;
}
export type TimestampUpdateSuccess = TimestampUpdateSuccessData & TypedAction<typeof TIMESTAMP_UPDATE_SUCCESS>;
export function timestampUpdateSuccess(timestamp?: Date): TimestampUpdateSuccess {
	return {
		type: TIMESTAMP_UPDATE_SUCCESS,
		timestamp,
	};
}

export type GoLiveRequested = TypedAction<typeof GO_LIVE_REQUESTED> & { timeRange?: TimeRange };

export function goLiveRequested(timeRange?: TimeRange): GoLiveRequested {
	return {
		type: GO_LIVE_REQUESTED,
		timeRange,
	};
}

export type GoLiveSuccess = TypedAction<typeof GO_LIVE_SUCCESS>;

export function goLiveSuccess(): GoLiveSuccess {
	return {
		type: GO_LIVE_SUCCESS,
	};
}

export interface TimelineUpdateRequestedData {
	timeRange?: TimeRange;
	timestamp?: Date;
}

export type TimelineUpdateRequested = TimelineUpdateRequestedData & TypedAction<typeof TIMELINE_UPDATE_REQUESTED>;

export function timelineUpdateRequested(data: TimelineUpdateRequestedData): TimelineUpdateRequested {
	return {
		type: TIMELINE_UPDATE_REQUESTED,
		...data,
	};
}

export const timestampAddedToHistory = ((timestamp) => ({
	type: TIMESTAMP_ADDED_TO_HISTORY,
	payload: { timestamp },
})) satisfies (timestamp?: number) => AnyAction;

export type SetLastSelectedDynamicInterval = TypedAction<typeof SET_LAST_SELECTED_DYNAMIC_INTERVAL> & {
	time: TimeRange;
};
export const setLastSelectedDynamicInterval = (time: TimeRange): SetLastSelectedDynamicInterval => ({
	type: SET_LAST_SELECTED_DYNAMIC_INTERVAL,
	time,
});
